<span class="secondary__link-icon" [hidden]="actionButtons.length == 0">
    @for(item of actionButtons; track item; let i = $index){
    <a (click)="onUserAction(item)" [hidden]="item.isHidden" [ngClass]="item.class" class="secondary-link">
        {{item.text}}
        @if(item.showGreenTick){<img [src]="ICONS.CHECK_CIRCLE"/>}
    </a>}
</span>